import {toAbsoluteUrl} from "../routes/Routes";
import axios from "axios";

export async function authentication ({code, verify, phone, accessToken}) {
  return axios({
    method: 'post',
    url: toAbsoluteUrl('/api/login'),
    data: {code, verify, phone, accessToken}
  });
}

export async function self (auth_token) {
  return axios({
    method: 'get',
    url: toAbsoluteUrl('/api/self'),
    headers: {'authorization': `Bearer ${auth_token}`}
  });
}

// TODO user form submission

export async function create (auth_token, user) {
  return axios({
    method: 'post',
    url: toAbsoluteUrl('/api/user'),
    headers: {'authorization': `Bearer ${auth_token}`},
    data: user
  });
}

export async function update (auth_token, user) {
  const { id } = user;
  return axios({
    method: 'patch',
    url: toAbsoluteUrl(`/api/user/${id}`),
    headers: {'authorization': `Bearer ${auth_token}`},
    data: user
  });
}
